import { render, staticRenderFns } from "./simpleTextLayerDrawer.vue?vue&type=template&id=296abc9a&"
import script from "./simpleTextLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./simpleTextLayerDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports